module.exports = __webpack_public_path__ + "img/star-wars-light-small.5df9c3bd.svg";